import { OrgExperienceInterface } from '../../../../../../types/ClientApplication';
import { UploadedFiles } from '../../../../../../types/Shared';
import { capitalize, formatDate3 } from '../../../../../../utils';
import {
  KeyPrincipalInterface,
  PriorProjectInterface,
} from '../../../../../Applications/CCLFForm/type';
import {
  clientApplicationConstructionType,
  clientApplicationProjectType,
} from '../../../../../Applications/ClientApplication/constants';
import { CurrencyFormatDisplay } from '../../../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';
import AttachmentContainer, {
  Attachment,
} from '../../../EnterpriseLBADevelopers/EnterpriseLBADeveloper/Attachments';
import { PrincipalResume } from './PrincipalResumes';
import { PriorProjects } from './PriorProjects';

export default function OrganizationExperience({
  organizationExperience,
  files,
}: {
  organizationExperience: OrgExperienceInterface;
  files: UploadedFiles[];
}) {
  return (
    <>
      <section aria-labelledby='applicant-information-title'>
        <div className='bg-white shadow sm:rounded-lg'>
          <div className='py-5'>
            <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
              <h2
                id='applicant-information-title'
                className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'
              >
                Organization Experience
              </h2>
              <p className='mt-1 max-w-2xl text-sm text-gray-500'>
                Details of an organization experience.
              </p>
            </div>
          </div>
          <div className='border-t border-gray-200 px-4 py-5 sm:px-6 space-y-5'>
            <p className='text-md font-bold'>Prior Projects</p>
            <dl className='w-full space-y-5'>
              {organizationExperience?.priorProjects?.map(
                (project: PriorProjectInterface, idx) => {
                  const priorProjectFiles = files?.filter((file) =>
                    file.field.includes(`pictures:${project.arrayId}`)
                  );
                  return (
                    <PriorProjects
                      key={idx}
                      index={idx}
                      project={project}
                      files={priorProjectFiles}
                    />
                  );
                }
              )}
            </dl>
          </div>
          <div className='border-t border-gray-200 px-4 py-5 sm:px-6 space-y-5'>
            <p className='text-md font-bold'>Key Principals</p>
            <dl className='grid grid-cols-2 col-span-2 gap-4'>
              {organizationExperience?.keyPrincipals?.map(
                (principal: KeyPrincipalInterface, idx) => {
                  const principalFiles = files?.filter((file) =>
                    file.field.includes(`principalResumes:${principal.arrayId}`)
                  );
                  return (
                    <PrincipalResume
                      key={idx}
                      principal={principal}
                      files={principalFiles}
                      index={idx}
                    />
                  );
                }
              )}
            </dl>
          </div>
        </div>
      </section>
    </>
  );
}
